import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import VideoSection from "../components/videoSection"

const Videos = () => (
  <Layout withBrand slidePosition={0} background={"#EAEAEA"}>
    <SEO
      description="Check out the Wersel Workdesk resource center to find videos that answer your questions about brand analytics, brand protection, counterfeit, ecommerce video analytics and more."
      keywords="brand analytics, wersel brand analytics, ecommerce analytics, brand protection, anti counterfeit solutions, wersel data hub"
      title="Video Resources - Wersel Workdesk"
      url="www.wersel.io/videos"
    />
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    <VideoSection />
  </Layout>
)

export default Videos
